export const postTypes = {
    'Social Media - Feed': 1,
    'Social Media - Story': 2,
    Broadcast: 3,
    Stream: 4,
};
